import React, { useEffect } from "react";

interface UnsavedChangesDialogProps {
  isOpen: boolean;
  onConfirm: () => void; // Leave without saving
  onSave: () => void; // Save and continue
}

export default function UnsavedChangesDialog({
  isOpen,
  onConfirm,
  onSave,
}: Readonly<UnsavedChangesDialogProps>) {
  useEffect(() => {
    // Add beforeunload listener to handle browser refresh/close
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (isOpen) {
        event.preventDefault();
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[200] p-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl p-6 w-full max-w-sm animate-fade-in relative">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          You have unsaved changes
        </h3>
        <p className="text-gray-600 dark:text-gray-300 mb-6 text-sm">
          Do you want to save your changes before leaving this page?
        </p>

        <div className="flex justify-end gap-3">
          <button
            type="button"
            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors text-sm font-medium"
            onClick={onConfirm}
          >
            Cancel
          </button>

          <button
            type="button"
            className="px-4 py-2 bg-brand-primary text-white rounded-md hover:bg-brand-hover transition-colors text-sm font-medium"
            onClick={onSave}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
